import { render, staticRenderFns } from "./PAQS.vue?vue&type=template&id=21f54196&scoped=true&"
import script from "./PAQS.vue?vue&type=script&lang=js&"
export * from "./PAQS.vue?vue&type=script&lang=js&"
import style0 from "./PAQS.vue?vue&type=style&index=0&id=21f54196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f54196",
  null
  
)

export default component.exports